import * as React from "react";

const PdfFileIcon = ({className}: {className: string}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 12.325h2a2 2 0 1 0 0-4H3v8m14-4h3m1-4h-4v8m-7-8v8h2a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z"
    ></path>
  </svg>
);

export default PdfFileIcon;
